<template>
  <div>
    <v-btn
      color="primary"
      :loading="loading"
      type="submit"
      x-large
      @click="loginButton"
      class="auth-btn microsoft-login-btn">
      <img src="@/assets/images/svg/microsoft-logo.svg" alt="logo" />
      {{ $t("auth.login_microsoft") }}
    </v-btn>
  </div>
</template>

<script>
  import { userManager } from "@/utility/zitadelLoginModule";

  export default {
    name: "ZitadelLoginModule",
    data() {
      return {
        userManager: userManager,
        loading: false,
      };
    },
    methods: {
      async loginButton() {
        try {
          this.loading = true;
          const user = await this.userManager.signinPopup();
          await this.loginInSR(user);
        } catch (error) {
          this.$emit("error", String(error));
          console.error(error);
        } finally {
          this.loading = false;
        }
      },
      async loginInSR(user) {
        const response = await fetch(`${process.env.VUE_APP_API_URL}/auth/login/zitadel`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/ld+json",
          },
          body: JSON.stringify({
            accessToken: user.access_token,
          }),
          credentials: "include",
        });
        if (response.status < 200 || response.status >= 300) {
          const result = await response.json();
          throw new Error(result["hydra:description"]);
        } else {
          const data = await response.json();
          this.$store.dispatch("SET_USER_DATA", data.user);
          this.$router.push({ name: "dashboard" });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";
  @import "@core/preset/preset/typography/index.scss";

  .microsoft-login-btn {
    padding: 10px 15px !important;
    width: 100%;
    position: relative;
  }

  .microsoft-login-btn img {
    width: 24px;
    height: 24px;
    position: absolute;
    left: 0;
  }
</style>
